import React, { useEffect, useState } from 'react';
import { ShoppingCartIcon, XIcon } from 'lucide-react';
type Purchase = {
  name: string;
  country: string;
  time: string;
};
const purchases: Purchase[] = [{
  name: 'Valentina R.',
  country: 'Argentina',
  time: 'hace 2 minutos'
}, {
  name: 'Camila M.',
  country: 'México',
  time: 'hace 5 minutos'
}, {
  name: 'Sofía L.',
  country: 'Colombia',
  time: 'hace 8 minutos'
}, {
  name: 'Martina G.',
  country: 'Chile',
  time: 'hace 11 minutos'
}, {
  name: 'Lucía P.',
  country: 'Uruguay',
  time: 'hace 14 minutos'
}, {
  name: 'Daniela F.',
  country: 'Perú',
  time: 'hace 17 minutos'
}, {
  name: 'Carolina V.',
  country: 'Venezuela',
  time: 'hace 20 minutos'
}, {
  name: 'Fernanda T.',
  country: 'España',
  time: 'hace 23 minutos'
}, {
  name: 'Gabriela S.',
  country: 'Bolivia',
  time: 'hace 26 minutos'
}, {
  name: 'Andrea N.',
  country: 'Ecuador',
  time: 'hace 29 minutos'
}];
export function PopupNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [animClass, setAnimClass] = useState('popup-enter');
  useEffect(() => {
    // Show first popup after 3 seconds
    const initialTimer = setTimeout(() => {
      setVisible(true);
      setAnimClass('popup-enter');
    }, 3000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 4 seconds
    const hideTimer = setTimeout(() => {
      setAnimClass('popup-exit');
      setTimeout(() => {
        setVisible(false);
        setCurrentIndex(prev => (prev + 1) % purchases.length);
      }, 500);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  useEffect(() => {
    if (visible) return;
    // Show next popup after 6 seconds gap
    const nextTimer = setTimeout(() => {
      setVisible(true);
      setAnimClass('popup-enter');
    }, 6000);
    return () => clearTimeout(nextTimer);
  }, [visible]);
  const purchase = purchases[currentIndex];
  if (!visible) return null;
  return <div className={`fixed bottom-6 left-4 z-50 ${animClass}`} style={{
    maxWidth: '320px'
  }} data-id="element-1">
      <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-3" data-id="element-2">
        <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-3">
          <ShoppingCartIcon className="w-5 h-5 text-green-600" data-id="element-4" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-5">
          <p className="text-xs text-gray-500 mb-0.5" data-id="element-6">Compra reciente</p>
          <p className="text-sm font-bold text-gray-900 font-montserrat" data-id="element-7">
            {purchase.name} de {purchase.country}
          </p>
          <p className="text-xs text-gray-600 mt-0.5" data-id="element-8">
            acaba de comprar{' '}
            <span className="font-semibold text-red-600" data-id="element-9">
              Airfryer sin Estrés
            </span>
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-10">{purchase.time}</p>
        </div>
        <button onClick={() => {
        setAnimClass('popup-exit');
        setTimeout(() => setVisible(false), 500);
      }} className="flex-shrink-0 text-gray-300 hover:text-gray-500 transition-colors" aria-label="Cerrar notificación" data-id="element-11">
          <XIcon className="w-4 h-4" data-id="element-12" />
        </button>
      </div>
    </div>;
}